//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    question: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      visible: false
    }
  },
  methods: {
    showQuestion () {
      this.visible = !this.visible
    }
  }
}
